import type { ReactNode } from 'react';

interface OnboardingStepProps {
  title: string;
  description: string;
  children: ReactNode;
  stepNumber: number;
  totalSteps: number;
}

export default function OnboardingStep({
  title,
  description,
  children,
  stepNumber,
  totalSteps,
}: OnboardingStepProps) {
  const progress = totalSteps > 0 ? (stepNumber / totalSteps) * 100 : 0;

  return (
    <div className="w-full max-w-2xl mx-auto">
      <div className="mb-6">
        <div className="flex justify-between text-sm text-gray-600 dark:text-gray-300 mb-2">
          <span>
            Step {stepNumber} of {totalSteps}
          </span>
          <span>{Math.round(progress)}% complete</span>
        </div>
        <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
          <div
            className="bg-purple-600 h-2 rounded-full transition-all duration-300"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">{title}</h2>
        <p className="text-gray-600 dark:text-gray-300 mb-6">{description}</p>
        <div className="space-y-4">{children}</div>
      </div>
    </div>
  );
}
